import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Blog.css';

gsap.registerPlugin(ScrollTrigger);

const posts = [
  { id: 1, tag: 'Stampa 3D', title: 'Come scegliere il filamento giusto per il tuo progetto', date: 'Prossimamente', color: '#bf00ff' },
  { id: 2, tag: 'Laser', title: 'Guida all\'incisione laser su metallo: parametri e tecniche', date: 'Prossimamente', color: '#00ccff' },
  { id: 3, tag: 'Tech', title: 'Intelligenza artificiale nella produzione maker: il futuro è ora', date: 'Prossimamente', color: '#00ff88' },
];

const Blog: React.FC = () => {
  useEffect(() => {
    gsap.fromTo('.blog-title',
      { y: 60, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: 'power3.out',
        scrollTrigger: { trigger: '.blog-title', start: 'top 80%' } }
    );
    document.querySelectorAll('.blog-card').forEach((card, i) => {
      gsap.fromTo(card,
        { y: 60, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', delay: i * 0.15,
          scrollTrigger: { trigger: card, start: 'top 85%' } }
      );
    });
  }, []);

  return (
    <section id="blog" className="blog">
      <div className="container">
        <div className="section-header blog-title">
          <span className="section-tag">— Conoscenza condivisa</span>
          <h2 className="section-title">
            Dal nostro <span className="highlight">blog</span>
          </h2>
          <p className="section-desc">
            Articoli tecnici, guide e novità dal mondo maker e tecnologico.
          </p>
        </div>

        <div className="blog-grid">
          {posts.map((post) => (
            <div className="blog-card" key={post.id} style={{ '--accent': post.color } as any}>
              <div className="blog-placeholder">
                <div className="blog-placeholder-content">
                  <span style={{ color: post.color }}>◈</span>
                  <span>Articolo in arrivo</span>
                </div>
              </div>
              <div className="blog-content">
                <span className="blog-tag" style={{ color: post.color }}>{post.tag}</span>
                <h3 className="blog-post-title">{post.title}</h3>
                <div className="blog-footer">
                  <span className="blog-date">{post.date}</span>
                  <span className="blog-read">Leggi →</span>
                </div>
              </div>
              <div className="blog-card-line" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
